export default __webpack_public_path__ + "navigation-guides-ui-steps-view-controller-1200-c97c8c88e61e994e5e2f8e2d0b9b3227.png";